(function () {
  'use strict';

  var ROOT_SELECTOR = '[data-atp-part-number-verifier]';
  var RESULT_BASE_CLASS = 'atp-part-number-verifier__result';

  function normalizePartNumber(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9]/g, '');
  }

  function splitPartNumbers(value) {
    if (Array.isArray(value)) return value;
    if (value === null || typeof value === 'undefined') return [];
    return String(value).split(/[,;|\n\r]+/);
  }

  function parseMetafieldData(rawValue) {
    if (!rawValue) return [];

    try {
      return splitPartNumbers(JSON.parse(rawValue));
    } catch (error) {
      return splitPartNumbers(rawValue);
    }
  }

  function isPartNumberLabel(label) {
    var normalized = normalizePartNumber(label);

    return normalized === 'partnumber' ||
      normalized === 'partnumbers' ||
      normalized === 'crossreference' ||
      normalized === 'crossreferences' ||
      (normalized.indexOf('crossreference') !== -1 && normalized.indexOf('partnumber') !== -1);
  }

  function hideAndReadDescriptionRows(root) {
    var scope = root.closest('.shopify-section') || root.closest('.product') || document;
    var rows = scope.querySelectorAll('.product-description table tr');
    var values = [];

    Array.prototype.forEach.call(rows, function (row) {
      var cells = Array.prototype.filter.call(row.children, function (child) {
        return child.tagName === 'TD' || child.tagName === 'TH';
      });

      if (cells.length < 2 || !isPartNumberLabel(cells[0].textContent)) return;

      row.hidden = true;
      row.setAttribute('aria-hidden', 'true');

      Array.prototype.slice.call(cells, 1).forEach(function (cell) {
        values = values.concat(splitPartNumbers(cell.textContent));
      });
    });

    return values;
  }

  function uniqueNormalized(values) {
    var seen = Object.create(null);

    return values.map(normalizePartNumber).filter(function (value) {
      if (!value || seen[value]) return false;
      seen[value] = true;
      return true;
    });
  }

  function initVerifier(root) {
    if (!root || root.dataset.atpInitialized === 'true') return;
    root.dataset.atpInitialized = 'true';

    var descriptionValues = hideAndReadDescriptionRows(root);
    var metafieldValues = parseMetafieldData(root.getAttribute('data-part-numbers'));
    var useDescriptionFallback = root.getAttribute('data-description-fallback') !== 'false';
    var sourceValues = metafieldValues.length ? metafieldValues : (useDescriptionFallback ? descriptionValues : []);
    var partNumbers = uniqueNormalized(sourceValues);

    if (!partNumbers.length) {
      root.hidden = true;
      return;
    }

    var input = root.querySelector('.atp-part-number-verifier__input');
    var button = root.querySelector('.atp-part-number-verifier__button');
    var result = root.querySelector('.atp-part-number-verifier__result');

    if (!input || !button || !result) return;

    root.hidden = false;

    function showResult(message, state) {
      result.textContent = message;
      result.className = RESULT_BASE_CLASS + ' ' + RESULT_BASE_CLASS + '--' + state;
      result.hidden = false;
    }

    function clearResult() {
      result.textContent = '';
      result.className = RESULT_BASE_CLASS;
      result.hidden = true;
    }

    function checkPartNumber() {
      var query = normalizePartNumber(input.value);

      if (!query) {
        showResult('Please enter a part number.', 'warning');
        input.focus();
        return;
      }

      if (partNumbers.indexOf(query) !== -1) {
        showResult(
          'Match found! This part number appears in our cross-reference list. Please confirm final fitment using your engine serial number or VIN.',
          'match'
        );
      } else {
        showResult(
          'No exact match was found. Contact us before ordering so we can verify your application.',
          'no-match'
        );
      }
    }

    button.addEventListener('click', checkPartNumber);
    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        checkPartNumber();
      }
    });
    input.addEventListener('input', clearResult);
  }

  function initAll(scope) {
    var roots = [];

    if (scope && scope.matches && scope.matches(ROOT_SELECTOR)) roots.push(scope);
    if (scope && scope.querySelectorAll) {
      roots = roots.concat(Array.prototype.slice.call(scope.querySelectorAll(ROOT_SELECTOR)));
    }

    roots.forEach(initVerifier);
  }

  function boot() {
    initAll(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
